const capitalizeFirstLetter = (value: string) =>
  value.charAt(0).toUpperCase() + value.toLowerCase().slice(1)

export const capitalize = (value: string) =>
  value.trim().split(' ').map(capitalizeFirstLetter).join(' ')
